export const APP_LANGUAGES = ['ar', 'en'];

export const DEFAULT_LANGUAGE = 'ar';

export const LANGUAGES_LABELS = {
  ar: 'العربية',
  en: 'English',
};

export const LANGUAGE_CACHE_KEY = 'CR_LANGUAGE';
